/**
 * LabelFactory - Creates text label sprites for 3D visualization
 */
import * as THREE from 'three';

export class LabelFactory {
  /**
   * Create a text label sprite for waypoints
   * @param {string} text - Label text
   * @returns {THREE.Sprite} Label sprite
   */
  static createWaypointLabel(text) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = 128;
    canvas.height = 64;
    context.font = 'Bold 48px Arial';
    context.fillStyle = 'white';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, 64, 32);

    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.scale.set(0.15, 0.075, 1);
    return sprite;
  }

  /**
   * Create a feature label with dynamic sizing
   * @param {string} text - Label text
   * @returns {THREE.Sprite} Label sprite
   */
  static createFeatureLabel(text) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = 256;
    canvas.height = 64;
    context.font = 'Bold 32px Arial';
    context.fillStyle = 'white';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, 128, 32);

    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.scale.set(0.25, 0.0625, 1);
    return sprite;
  }

  /**
   * Create axis label sprite
   * @param {string} text - Axis label (X, Y, Z)
   * @param {string} color - CSS color string
   * @param {THREE.Vector3} position - Label position
   * @returns {THREE.Sprite} Label sprite
   */
  static createAxisLabel(text, color, position) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = 64;
    canvas.height = 64;
    context.font = 'Bold 48px Arial';
    context.fillStyle = color;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(text, 32, 32);

    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.position.copy(position);
    sprite.scale.set(0.3, 0.3, 1);
    return sprite;
  }
}
